/* eslint-disable */

import React from 'react';
import {Route, IndexRoute} from 'react-router';

import config from './config';
const r = config.routes;

import App from './components/App/App.jsx';
import NotFoundPage from './components/NotFoundPage/NotFoundPage.jsx';
import Test from './components/Common/Test.jsx';
import MainPage from './components/MainPage/MainPage.jsx';
//import CartPage from './components/CartPage/CartPage.jsx';
import Cart from './components/Cart/index.jsx';
//import CheckoutPage from './components/CheckoutPage/CheckoutPage.jsx';
//import PayoutPage from './components/PayoutPage/PayoutPage.jsx';
import SearchResults from './components/SearchResults/SearchResults.jsx';
import Search from './components/Search/index.jsx';
import Catalog from './components/Catalog/Catalog.jsx';
import Categories from './components/Catalog/Categories.jsx';
import Modifications from './components/Catalog/Modifications.jsx';
import ComponentList from './components/Catalog/ComponentList.jsx';
import User from './components/User/User.jsx';
import Garage from './components/User/Garage.jsx';
import GarageCatalog from './components/User/elements/GarageCatalog.jsx';
import GarageModifications from './components/User/elements/GarageModifications.jsx';
import GarageSaveCar from './components/User/elements/GarageSaveCar.jsx';
import Balance from './components/User/Balance.jsx';
import Orders from './components/User/Orders.jsx';
import SupplierRegistration from './components/Supplier/SupplierRegistration.jsx';

export default (
  <Route path={r.main} component={App}>
    <IndexRoute component={MainPage}/>
    <Route path="/secondlogin" component={MainPage}/>
    <Route path={r.results} component={SearchResults}/>
    <Route path={r.search} component={Search}/>
    <Route path={r.user} component={User}/>
    <Route path={r.garage} component={Garage}>
      <Route path={`${r.garage}/:brand`} component={GarageCatalog}/>
      <Route path={`${r.garage}/:brand/:modelId`} component={GarageModifications}/>
      <Route path={`${r.garage}-set/:modificationId`} component={GarageSaveCar}/>
    </Route>

    <Route path={r.balance} component={Balance}/>
    <Route path={r.orders} component={Orders}/>

    <Route path={r.categories} component={Categories}/>
    <Route path={`${r.catalog}/:brand`} component={Catalog}>
      <Route path={`${r.modifications}/:brand/:modelId`}
             component={Modifications}>
        <Route path={`${r.components}/:modification`}
               component={ComponentList}/>
      </Route>
    </Route>

   {/* <Route path={r.cart} component={CartPage}>
      <Route path={r.checkout} component={CheckoutPage}>
        <Route path={r.payout} component={PayoutPage}/>
      </Route>
      <Route path={r.thanksPage} component={CheckoutPage}/>
    </Route>*/}
    <Route path={r.basket} component={Cart}/>
    <Route path={r.registration} component={SupplierRegistration}/>
    <Route path="/test" component={Test}/>

    <Route path="*" component={NotFoundPage}/>
  </Route>

);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/